"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArticle = void 0;
var useArticle_1 = require("./useArticle");
Object.defineProperty(exports, "useArticle", { enumerable: true, get: function () { return useArticle_1.useArticle; } });
//# sourceMappingURL=index.js.map